export const countDuplicates = (arr: any[]) => {
    const counts = arr.reduce((acc, item) => {
      acc[item] = (acc[item] || 0) + 1;
      return acc;
    }, {});
    
    const duplicatesList = Object.values(counts).filter((count: any) => count > 1)
    const totalDuplicates: any = duplicatesList.reduce((accum: any, item: any) => {
      return accum + item - 1
    }, 0)
    // @ts-ignore
    return totalDuplicates;
  }
export const countDuplicates = (arr: any[]) => {
    const counts = arr.reduce((acc, item) => {
      acc[item] = (acc[item] || 0) + 1;
      return acc;
    }, {});
    
    const duplicatesList = Object.values(counts).filter((count: any) => count > 1)
    const totalDuplicates: any = duplicatesList.reduce((accum: any, item: any) => {
      return accum + item - 1
    }, 0)
    // @ts-ignore
    return totalDuplicates;
  }
